/*
 * Maps each Module Federation remote name to the URL of its remote-entry file.
 * Built from the same `buildRemoteUrls` factory that vite.config.js feeds to the
 * federation plugin, so the import-error classifier always probes the exact URL
 * the federation runtime fetches — one declaration, no drift.
 */

import buildRemoteUrls from '@/constants/federationRemotes';

const REMOTE_URLS = buildRemoteUrls(import.meta.env);

/**
 * Resolve a remote name (e.g. 'panda') to its remote-entry URL.
 * Returns null for unknown names so callers can degrade to a non-probed category.
 * @param {string} remoteName
 * @returns {string|null}
 */
const remoteUrlFor = (remoteName) => REMOTE_URLS[remoteName] || null;

export { REMOTE_URLS, remoteUrlFor };
